<template>
  <div class="deliver-guide-dialog">
    <el-row class="select-card-list" :gutter="20">
      <el-col :span="12" v-for="item in makeAppSelectList" :key="item.name">
        <div
          @click="() => handlerSelect(item)"
          :class="[item.type === selectedCard.type ? 'active' : '', 'select-card']"
        >
          <div v-if="item.type === 'DETAIL'" class="select-card__svg-icon select-card__detail wsp-icon-xiangqing"></div>
          <div v-if="item.type === 'BASE'" class="select-card__svg-icon select-card__base wsp-icon-jichu"></div>
          <div class="select-card__title">{{ item.name }}</div>
          <div class="select-card__des">{{ item.des }}</div>
        </div>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="$emit('confirm', selectedCard)">{{ confirm }}</el-button>
      <el-button @click="$emit('cancel')">{{ cancel }}</el-button>
    </div>
  </div>
</template>
<script>
import { Col, Row, Button } from 'element-ui'
// import { SkSvgIcon } from 'sk-ui'

import lang from '@/lang'
export default {
  name: 'collectPocDialog',
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data() {
    return {
      selectedCard: {
        icon: 'appPush',
        name: lang.t('pocMng.collectPocDialog.createDetailProject'),
        des: lang.t('pocMng.collectPocDialog.createDetailProjectDesc'),
        type: 'BASE'
      },
      makeAppSelectList: [
        {
          icon: 'appPush',
          name: lang.t('pocMng.collectPocDialog.createDetailProject'),
          des: lang.t('pocMng.collectPocDialog.createDetailProjectDesc'),
          type: 'DETAIL'
        },
        {
          icon: 'appDisk',
          name: lang.t('pocMng.collectPocDialog.createBaseProject'),
          des: lang.t('pocMng.collectPocDialog.createBaseProjectDesc'),
          type: 'BASE'
        }
      ],
      cancel: lang.t('pocMng.btns.cancel'),
      confirm: lang.t('pocMng.btns.confirm')
    }
  },
  methods: {
    handlerSelect(selected) {
      this.selectedCard = selected
    }
  }
}
</script>
<style lang="scss" scoped>
.select-card {
  padding: 18px 12px;
  border: 3px solid #e6e4e5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgba(0, 0, 0, 0.72);
  height: 222px;
  cursor: pointer;
  &__svg-icon {
    font-size: 100px;
  }
  &__base {
    color: #1afa29;
  }
  &__detail {
    color: #1afac2;
  }
  &__title {
    text-align: center;
    padding: 11px 8px;
    font-size: 14px;
  }
  &__des {
    font-size: 12px;
  }
  &.active {
    border: 3px solid #449ee6;
  }
  &:hover {
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  }
}
.dialog-footer {
  margin-top: 16px;
  text-align: right;
}
</style>
